import { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from "@mui/material"
import { useTranslation } from "react-i18next";

const ScannerPremissionDialog = () => {
    const { t } = useTranslation();
    const [permInfoOpen, setPermInfoOpen] = useState(false)
    const [hasCamera, setHasCamera] = useState(true);
    const [cameraPermission, setCameraPermission] = useState(null);

    // Check for connected camera devices
    useEffect(() => {
        async function checkCameraDevices() {
            if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
                const devices = await navigator.mediaDevices.enumerateDevices();
                const videoInputs = devices.filter(device => device.kind === 'videoinput');
                setHasCamera(videoInputs.length > 0);
            } else {
                setHasCamera(false);
            }
        }
        checkCameraDevices();
    }, []);

    // Check for camera permission and listen for changes
    useEffect(() => {
        let permissionStatusObj = null;
        async function checkPermission() {
            if (navigator.permissions && navigator.permissions.query) {
                try {
                    const result = await navigator.permissions.query({ name: 'camera' });
                    setCameraPermission(result.state);
                    permissionStatusObj = result;
                    // Listen for permission changes
                    result.onchange = () => {
                        setCameraPermission(result.state);
                    };
                } catch {
                    setCameraPermission(null);
                }
            }
        }
        checkPermission();
        return () => {
            if (permissionStatusObj && permissionStatusObj.onchange) {
                permissionStatusObj.onchange = null;
            }
        };
    }, []);

    useEffect(() => {
        // Show dialog if no camera or permission not granted
        if (!hasCamera || cameraPermission === 'denied' || cameraPermission === 'prompt') {
            setPermInfoOpen(true);
        } else {
            setPermInfoOpen(false);
        }
    }, [hasCamera, cameraPermission]);

    const onOkHandle = async () => {
        try {
            // Request camera permission by accessing the camera
            await navigator.mediaDevices.getUserMedia({ video: true });
            setCameraPermission('granted');
        } catch {
            setCameraPermission('denied');
        }
        setPermInfoOpen(false);
    }

    return (
        <Dialog open={permInfoOpen}>
            <Stack>
                <DialogTitle>
                    {t('CAMERA_PERMISSIONS_TITLE')}
                </DialogTitle>
                <DialogContent>
                    <Typography>
                        {t('NEED_CAMERA_PERMISSIONS_MESSAGE')}
                    </Typography>

                    <Typography>
                        {!hasCamera
                            ? t('NO_CAMERA_FOUND')
                            : t('CAMERA_PERMISSIONS_MESSAGE')
                        }
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant='contained'
                        onClick={onOkHandle}
                    >
                        {t('OK')}
                    </Button>
                </DialogActions>
            </Stack>
        </Dialog>
    )
}

export default ScannerPremissionDialog